import React from "react";

const MAP = {
  paid: ["Paid", "bg-green-50 text-green-700 border-green-200"],
  pending: ["Pending", "bg-orange-50 text-orange-700 border-orange-200"],
  overdue: ["Overdue", "bg-red-50 text-red-700 border-red-200"],
  void: ["Void", "bg-slate-100 text-slate-600 border-slate-200"],
};

export default function InvoiceBadge({ status }) {
  const [label, cls] = MAP[status] || [status, "bg-slate-100 text-slate-600 border-slate-200"];
  return <span className={`inline-block text-[11px] px-2 py-0.5 rounded-md border font-medium ${cls}`}>{label}</span>;
}

export function SubscriptionBadge({ status }) {
  const lapsed = status === "lapsed";
  return (
    <span className={`inline-block text-[11px] px-2 py-0.5 rounded-md border font-medium ${lapsed ? "bg-red-50 text-red-700 border-red-200" : "bg-green-50 text-green-700 border-green-200"}`}>
      {lapsed ? "Lapsed" : "Active"}
    </span>
  );
}
